import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const controllerPath = `${BASE_PATH_API}/generalLedger`;

const actions = {
    searchTransactions: {
        method: 'POST',        
        url: `${controllerPath}/transactions`,
        isArray: true,
        transformRequestData: function transformRequestData(data) {
            if (data.GlAccountIds) {
                data.GlAccountIds = data.GlAccountIds.filter(x => !!x);
            }

            if (data.UnitIds) {
                data.UnitIds = data.UnitIds.filter(x => !!x);
            }

            return data;
        }
    },
    createJournalEntry: {
        method: 'POST',        
        url: `${controllerPath}/journalEntry`
    },
    getJournalEntryByJournalId: {
        method: 'GET',
        url: `${controllerPath}/journalEntry/:journalId`
    },
    updateJournalEntry: {
        method: 'PUT',
        url: `${controllerPath}/journalEntry/:journalId`
    },
    deleteJournalEntry: {
        method: 'DELETE',
        url: `${controllerPath}/journalEntry/:journalId`
    },
    getReversedEftPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/reversedEftPayments/:id`
    },
    getReversedOwnerContribution: {
        method: 'GET',
        url: `${BASE_PATH_API}/reversedOwnerContributions/:id`
    },
    getReversedPayment: {
        method: 'GET',
        url: `${BASE_PATH_API}/reversedPayments/:id`
    },
    deleteReversedPayment: {
        method: 'delete',
        url: `${BASE_PATH_API}/reversedPayments/:id`
    },
    getReversedEftRefund: {
        method: 'GET',
        url: `${BASE_PATH_API}/reversedEftRefunds/:id`
    },
};

export function GeneralLedgerApi() {
    return createActions(actions);
}
